<template>
  <div class="total-bill">
    <div v-if="totalBill.totalSumFeeAmount && totalBill.forteServiceFee" class="fees">
      <div>
        <div>{{ totalBill.rimsFeeName }}</div>
        <div>{{ toCurrency(totalBill.rimsTotalFeeAmount) }}</div>
      </div>
      <div>
        <div>Service fee for the third party provider</div>
        <div>{{ toCurrency(totalBill.forteServiceFee) }}</div>
      </div>
      <div>
        <div>Total bill</div>
        <div class="total-amount">{{ toCurrency(totalBill.totalSumFeeAmount) }}</div>
      </div>
    </div>
    <div v-else class="fetching">
      <p>
        Fetching fee details
      </p>
      <div class="snippet" data-title=".dot-typing">
        <div class="stage">
          <div class="dot-typing"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { toCurrency } from '../../../utils/globalFilters';

// Props
defineProps({
  totalBill: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});
</script>


<style lang="scss" scoped>
.total-bill {
  background-color: var(--ri-darker-blue);
  color: white;
  min-width: 50%;
  margin: 1em 0;
  padding: 1em 1.5em;
  .fees {
    > div {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 2em;
      min-height: 2.25em;
      &:last-child {
        font-weight: 900;
      }
      .total-amount {
        color: var(--ri-orange);
      }
      div {
        &:first-child {
          flex-basis: 160px;    // fluid widths can be problematic in small screens
        }
        &:last-child {
          text-align: right;
          flex-basis: 100px;
        }
      }
    }
  }

  .fetching {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    p {
      padding-right: 1.5em;
    }
  }

  // https://nzbin.github.io/three-dots/
  --dot-color: white;
  --dot-size: 6px;
  .dot-typing {
    position: relative;
    left: -9999px;
    width: var(--dot-size);
    height: var(--dot-size);
    border-radius: 5px;
    background-color: var(--dot-color);
    color: var(--dot-color);
    box-shadow: 9984px 0 0 0 var(--dot-color), 9999px 0 0 0 var(--dot-color), 10014px 0 0 0 var(--dot-color);
    animation: dotTyping 1.5s infinite linear;
  }
  @keyframes dotTyping {
    0% {
      box-shadow: 9984px 0 0 0 var(--dot-color), 9999px 0 0 0 var(--dot-color), 10014px 0 0 0 var(--dot-color);
    }
    16.667% {
      box-shadow: 9984px -10px 0 0 var(--dot-color), 9999px 0 0 0 var(--dot-color), 10014px 0 0 0 var(--dot-color);
    }
    33.333% {
      box-shadow: 9984px 0 0 0 var(--dot-color), 9999px 0 0 0 var(--dot-color), 10014px 0 0 0 var(--dot-color);
    }
    50% {
      box-shadow: 9984px 0 0 0 var(--dot-color), 9999px -10px 0 0 var(--dot-color), 10014px 0 0 0 var(--dot-color);
    }
    66.667% {
      box-shadow: 9984px 0 0 0 var(--dot-color), 9999px 0 0 0 var(--dot-color), 10014px 0 0 0 var(--dot-color);
    }
    83.333% {
      box-shadow: 9984px 0 0 0 var(--dot-color), 9999px 0 0 0 var(--dot-color), 10014px -10px 0 0 var(--dot-color);
    }
    100% {
      box-shadow: 9984px 0 0 0 var(--dot-color), 9999px 0 0 0 var(--dot-color), 10014px 0 0 0 var(--dot-color);
    }
  }
}
</style>
